/**
 * @desc: Copy from https://git.perkbox.io/backend-services/onboarding-v2/blob/master/internal/errorLib/codes.go
 */

enum OnboardCodes {
  RequestUrlParamMissing = "PBONBRequestUrlParamMissing",
  RequestBodyInvalid = "PBONBRequestBodyInvalid",

  EmptyField = "PBONBEmptyField",

  OnboardingNotFound = "PBONBOnboardingNotFound",
  OnboardingAlreadyExists = "PBONBOnboardingAlreadyExists",
  FlowNotFound = "PBONBFlowNotFound",
  StepDoesNotBelong = "PBONBStepDoesNotBelong",

  UserDisabled = "PBONBUserDisabled",

  InitialOnboardingCompleted = "PBONBInitialOnboardingCompleted",
  ResendWelcomeEmailSamlUser = "PBONBResendWelcomeEmailSamlUser",

  BusinessOnboardingNotFound = "PBONBBusinessOnboardingNotFound",
  InvalidStepState = "PBONBInvalidState",
  InvalidStepSelection = "PBONBInvalidSelection"
}

export default OnboardCodes
